export default [
	'buying-a-home',
	'selling-a-home',
	'home-ownership',
	'finances',
	'lawn-and-garden',
	'maintenance-and-repair',
	'modern-home',
	'remodeling-renovation',
];
